<template>
  <div>
    <custom-callout :has-toggle="false" class="mt-3">
      <div class="row pt-2">
        <div class="col-md-2 col-6">
          <div class="info-text-title">
            Número SIE:
          </div>
          <p class="info-text">
            {{ value.studentSie }}
          </p>
        </div>
        <div class="col-md-3 col-6">
          <div class="info-text-title">
            Nombre de Estudiante:
          </div>
          <p class="info-text">
            {{ value.name }}
          </p>
        </div>
        <div class="col-md-2 col-6">
          <div class="info-text-title">
            Edad:
          </div>
          <p class="info-text">
            {{ value.age }}
          </p>
        </div>
        <div class="col-md-2 col-6">
          <div class="info-text-title">
            Grado:
          </div>
          <p class="info-text">
            {{ value.grade }}
          </p>
        </div>
        <div class="col">
          <div class="info-text-title">
            Impedimento:
          </div>
          <p class="info-text">
            {{ value.impediment }}
          </p>
        </div>
      </div>
    </custom-callout>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';

export default {
  name: 'StudentInfo',
  components: {
    CustomCallout,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  async mounted() {},
};
</script>

<style scoped>
::v-deep .border-left--color-secondary-12 {
  border-left-color: transparent !important;
}

::v-deep .border-top--color-secondary-12 {
  border-top-color: transparent !important;
}

.info-text-title {
  color: #727272;
  font-weight: normal;
}

.info-text {
  color: #11291b;
  font-weight: bold;
}
</style>
